import styled from "styled-components";

export const StyledDetailPageSummaryElement = styled.div`
  align-items: stretch;
  background: var(--White, #fff);
  border: 1px solid var(--Color-Tokens-Border-Primary, #e4e4e4);
  border-radius: 8px;
  display: flex;
  min-height: 96px;
  margin: 24px 24px 12px;
  overflow-x: auto;
  padding: 20px 0;
`;

export const StyledSummaryBarCellElement = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  min-width: max-content;
  padding: 0 24px;
`;

export const StyledSummaryBarCellLabelElement = styled.div`
  color: var(--SLATE, #5c6679);
  font-family: Inter, sans-serif;
  font-size: 11px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: 0.04em;
  line-height: 16px;
  text-transform: uppercase;
`;

export const StyledSummaryBarCellValueElement = styled.div`
  color: #0e0e2c;
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
`;

export const StyledSummaryBarCellUserValueElement = styled.div`
  align-items: center;
  color: #0e0e2c;
  display: flex;
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  gap: 8px;
  line-height: 22px;
`;

export const StyledSummaryBarCellUserAvatar = styled.span`
  align-items: center;
  background: var(--SKY, #cce5ff);
  border-radius: 50%;
  color: var(--DARK-BLUE, #1249bf);
  display: inline-flex;
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 700;
  height: 28px;
  justify-content: center;
  line-height: 1;
  width: 28px;
`;
export const StyledSummaryBarCellEditableValueElement = styled.input`
  color: #0e0e2c;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  background-color: transparent;
  border: none;
  outline: none;
`;

export const StyledSummaryBarCellBorderElement = styled.div`
  align-self: stretch;
  background-color: var(--Color-Tokens-Border-Primary, #e4e4e4);
  flex-shrink: 0;
  width: 1px;
`;
